import cn from 'classnames';
import React, { useEffect, useMemo } from 'react';
import * as PropTypes from 'prop-types';
import Popup from '../../../common/Popup';
import Button from '../../../Button';
import Loader from '../../../common/Loader';
import ConsentInfo from '../../../Consents/ConsentInfo';
import SignConsentButton from '../VisitConsents/ConsentDetailsPopup/SingConsentButton';
import useConsentOutcomesInfo from '../../../../hooks/consents/useConsentOutcomesInfo';
import useSignAppointmentConsent from '../../../../hooks/consents/useSignAppointmentConsent';
import { renderElectronicConsentHeader } from '../VisitConsents/utils/renderElectronicConsentHeader';
import getElectronicConsentHeaderRenderData from '../../utils/getElectronicConsentHeaderRenderData';
import { enhance } from './enhance';

import styles from './styles.styl';

const ElectronicConsentPopup = ({
  intl: { formatMessage },
  clearSignConsentData,
  isSignConsentLoading,
  isSignConsentSucceed,
  item,
  onClose,
  opened,
  providerContext,
}) => {
  const title = formatMessage({
    id: 'appointment.electronicConsent.details.titlePatient',
  });

  const {
    assignedBy,
    consentId,
    consentName,
    consentTypeName,
    consentVersionTitle,
    content,
    formatTime,
    multipleOutcomes,
    organizationName,
    outcomeTitles,
    userId,
    version,
  } = getElectronicConsentHeaderRenderData(item, formatMessage);

  const consent = useMemo(
    () => ({
      content,
      multipleOutcomes,
      name: consentName,
      outcomeTitles,
      typeName: consentTypeName,
      version,
      versionTitle: consentVersionTitle,
    }),
    [
      consentName,
      consentTypeName,
      consentVersionTitle,
      content,
      version,
      multipleOutcomes,
      outcomeTitles,
    ],
  );

  const {
    buttonAccept,
    consentOutcomeTitles,
    isConsentHasMultipleOutcomes,
  } = useConsentOutcomesInfo(consent);

  const handleAcceptConsent = useSignAppointmentConsent({
    consentId,
    userId,
    consentVersion: version,
  });

  useEffect(() => {
    if (isSignConsentSucceed) {
      onClose();
    }
  }, [isSignConsentSucceed]);

  useEffect(
    () => () => {
      clearSignConsentData();
      onClose();
    },
    [],
  );

  return (
    <Popup
      strictClose
      opened={opened}
      onClose={onClose}
      title={title}
      width="medium"
      mobileFullScreen={false}
    >
      <div
        className={cn(styles.root, {
          [styles.disableModal]: isSignConsentLoading,
        })}
      >
        <If condition={isSignConsentLoading}>
          <Loader className="absolute-center" />
        </If>
        {!providerContext && (
          <div className={styles.header}>
            {renderElectronicConsentHeader(
              formatMessage,
              assignedBy,
              consentName,
              organizationName,
              formatTime,
            )}
          </div>
        )}

        <div className={styles.consent}>
          <ConsentInfo consent={consent} />

          {!providerContext && (
            <SignConsentButton
              buttonAccept={buttonAccept}
              handleAcceptConsent={handleAcceptConsent}
              isConsentHasMultipleOutcomes={isConsentHasMultipleOutcomes}
              titles={consentOutcomeTitles}
            />
          )}
        </div>
      </div>
    </Popup>
  );
};

ElectronicConsentPopup.propTypes = {
  opened: PropTypes.bool,
  intl: PropTypes.object,
  item: PropTypes.object,
  onClose: PropTypes.func,
  providerContext: PropTypes.bool,
  isSignConsentSucceed: PropTypes.bool,
  isSignConsentLoading: PropTypes.bool,
  clearSignConsentData: PropTypes.func,
};

export default enhance(ElectronicConsentPopup);



// WEBPACK FOOTER //
// ./src/components/Healthboard/Components/ElectronicConsentPopup/index.jsx